import { useQueryFetch } from 'sonata-react-components';
import { normalizeWithUnit } from 'sonata-static-storage/lib/helpers/i18nUnits.helpers';

import { getWalletAmount } from '../../../services/wallet.resources';

import './infoWalletMenu.scss';

import type { CurrencyInfo } from 'sonata-static-storage/lib/samples/currencies.samples';

type Props = {
  currencyInfo: CurrencyInfo;
  user: Record<string, any>;
};

export function InfoWalletMenu({ currencyInfo, user }: Props) {
  const walletAmountToken = {};
  const {
    data: walletAmount = {
      amount: 0,
      currency: 'EUR'
    }
  } = useQueryFetch('wallet-amount', async () => getWalletAmount(user.id, walletAmountToken), {
    enabled: true
  });

  return (
    <div className="infoWalletMenu">
      <div className="infoWalletMenu__value">{normalizeWithUnit(walletAmount.amount, currencyInfo)}</div>
    </div>
  );
}
